module.exports = __webpack_public_path__ + "media/img/frond_end_agnets_card-92112d1aef8ee0a6d0e84a2616d0e30e.svg";